module.exports = __webpack_public_path__ + "img/23_62.f733f25e.png";